import React, { useState } from "react";

import { Container } from "@gamedev-web/gamedev-sdk-core";
import { Icon, IconSize } from "@gaming/xds-react-js";
import { ChevronDown, ChevronRight } from "@gaming/xds-react-js-icons";

import * as styles from "./FrequentlyAskedQuestion.module.css";

type FrequentlyAskedQuestionProps = {
  id: number;
  question?: string;
  answer?: string;
};

const FrequentlyAskedQuestion = (props: FrequentlyAskedQuestionProps) => {
  const [showAnswer, setShowAnswer] = useState(false);
  const toggleShowAnswer = () => setShowAnswer(!showAnswer);
  const { id, question, answer } = props;
  const answerId = `answer-${id}`; // Generate a unique ID for the answer

  return (
    <Container key={id} className={styles.frequentlyAskedQuestionContainer}>
      <h3>
        <button
          onClick={toggleShowAnswer}
          className={styles.questionButton}
          aria-expanded={showAnswer}
          aria-controls={answerId}
        >
          <div className={styles.frequentlyAskedQuestion}>
            <Icon
              icon={showAnswer ? ChevronDown : ChevronRight}
              aria-hidden={true}
              iconSize={IconSize.Custom}
            />
            <label className={styles.question}>{question}</label>
          </div>
        </button>
        {showAnswer && (
          <div id={answerId} className={styles.frequentlyAskedQuestionAnswer}>
            {answer}
          </div>
        )}
      </h3>
    </Container>
  );
};

export default FrequentlyAskedQuestion;
